import { Texture } from "three";
import { IFsFileType } from "@r3f-component-data-structure";
import { FsBaseFile } from "./base";
import { Jute } from "@/index";

export type HlsPlaylistType = 'auto' | 'low' | 'high' | 'hd' | 'vr';

export class FsVideo extends FsBaseFile {
    type: IFsFileType.Video | IFsFileType.Video360 = IFsFileType.Video
    mp4Url: string
    thumbnailUrl: string

    protected _thumbnailTexture: Texture | undefined
    protected _hasHls: boolean

    constructor(fileId: string, name: string, hasHls = true) {
        super(fileId, name)
        this._hasHls = hasHls
        if (this.id.startsWith('https://')) {
            this.baseUrl = this.id
        }
        const mp4Url = new URL(this.baseUrl)
        mp4Url.pathname = `${mp4Url.pathname}/video.mp4`
        this.mp4Url = mp4Url.toString()

        const thumbnailUrl = new URL(this.baseUrl)
        thumbnailUrl.pathname = `${thumbnailUrl.pathname}/frame0.png`
        this.thumbnailUrl = thumbnailUrl.toString()

        // const progressUrl = new URL(this.baseUrl)
        // progressUrl.pathname = `${progressUrl.pathname}/status.json`
        // this.progressUrl = progressUrl.toString()
    }

    // For App clips enforce hd quality as otherwise downgraded to lowest level
    getPlaylistUrl(type: HlsPlaylistType = Jute.isAppClip ? 'hd' : 'auto') {
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/${type}.m3u8`
        return url.toString()
    }

    getMp4Url() {
        return this.mp4Url
    }

    /**
     * The URL to play. A video the editor saved straight from a downloaded MP4 has no playlist —
     * useHlsLoader plays any non-m3u8 URL through a plain `video.src`, without hls.js.
     */
    getPlaybackUrl() {
        return this._hasHls ? this.getPlaylistUrl() : this.mp4Url
    }

    getThumbnailUrl() {
        return this.thumbnailUrl
    }

    async load() {
        return this
    }

    // Inherited unchanged by FsVideo360. Note the playing video element itself is not owned here — it
    // lives in useHlsLoader's cache, keyed by entity id rather than by URL.
    dispose(): void {
        super.dispose()
        this._thumbnailTexture?.dispose()
        this._thumbnailTexture = undefined
    }
}
